import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, empty } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private route: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = this.addAuthHeader(request);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        
        if (error.status === 401) {
          
          this.authService.logOut();
            
        }
        if (error.status === 403) {
          
          this.route.navigate(['/forbidden']);
            
        }

        return throwError(error);
      })
    );
  }
  refreshAccesToken() {
    return this.authService.getNewAccessToken().pipe(
      tap(()=>{
        console.log("Acces token Refreshed");
      })
    )
  }
  addAuthHeader(request: HttpRequest<any>) {
    const token = this.authService.getAccesToken;

    if(token) {
      return request.clone({
        setHeaders: {
          'Authorization': 'Bearer ' + token
        }
      })
    }
    return request;
  }
}
